import React, {Component} from 'react';
import {client} from '../../Client';
import ErrorMessage from '../ErrorMessage'
import {convertNullToEmptyString} from '../../Helpers'
import RubricaDetail from './RubricaDetail'
import PropTypes from 'prop-types';

class RubricaView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.match.params.id,
            fields: {},
            _loading: false

        };
        this.loadRubrica = this.loadRubrica.bind(this)
        this.onClickDelete = this.onClickDelete.bind(this)
    }

    componentDidMount() {
        this.loadRubrica();
    }

    loadRubrica(){
        this.setState({ _loading: true });

        client.loadRubrica(this.state.id).then(
            (response) => {
                if (response.ok){
                    response.json().then((item) => {
                        let fields = convertNullToEmptyString(item);
                        this.setState({ _loading: false, fields: fields,  fieldErrors: {}, error: null});
                        this.forceUpdate();
                    })
                }
                else if (response.status === 401)
                {
                    this.props.history.push('/login')

                }
                else
                {
                    response.json().then((errore) => {
                        this.setState({
                            _loading: false,
                            error: {title: errore.title, msg: errore.msg},
                        });
                    });

                }
            }).catch((error) => {

            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });

        });
    }

    onClickDelete(ev, soggetto){
        this.setState({_loading: true});
        client.deleteRubrica(soggetto).then((response) => {
            if (response.ok){
                this.setState({
                    _loading: false,
                    error: null
                });
                this.props.history.push("/app/rubrica")

            }
            else if (response.status === 401)
            {
                this.props.history.push('/login')
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });

    }

    render() {
        if (this.state.error != null){
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }
        else {
            return (<RubricaDetail
                item={this.state.fields}
                loading={this.state._loading}
                onClickDelete={this.onClickDelete}
                readOnly={client.getCurrentUser().isrolerubricaw === false}
            />)
        }
    }
}

RubricaView.contextTypes = {
    router: PropTypes.object
}

export default RubricaView;




/** WEBPACK FOOTER **
 ** ./src/components/rubrica/RubricaView.js
 **/